import React from 'react';
import Icon from '../../../components/AppIcon';

const LoadingState = ({ message = "Discovering cosmic connections..." }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-8">
      {/* Animated Constellation */}
      <div className="relative mb-8">
        {/* Central star */}
        <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center animate-gentle-pulse">
          <Icon name="Sparkles" size={32} color="white" />
        </div>
        
        {/* Orbiting elements */}
        <div className="absolute inset-0 animate-spin" style={{ animationDuration: '8s' }}>
          <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-accent rounded-full animate-gentle-pulse"></div>
        </div>
        
        <div className="absolute inset-0 animate-spin" style={{ animationDuration: '12s', animationDirection: 'reverse' }}>
          <div className="absolute top-1/2 -right-2 transform -translate-y-1/2 w-3 h-3 bg-secondary rounded-full animate-gentle-pulse"></div>
        </div>
        
        <div className="absolute inset-0 animate-spin" style={{ animationDuration: '10s' }}>
          <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-primary rounded-full animate-gentle-pulse"></div>
        </div>
        
        <div className="absolute inset-0 animate-spin" style={{ animationDuration: '15s', animationDirection: 'reverse' }}>
          <div className="absolute top-1/2 -left-2 transform -translate-y-1/2 w-3 h-3 bg-accent rounded-full animate-gentle-pulse"></div>
        </div>
        
        {/* Outer ring */}
        <div className="absolute inset-0 border-2 border-primary/20 rounded-full animate-spin" style={{ animationDuration: '20s' }}></div>
        <div className="absolute inset-2 border-2 border-secondary/20 rounded-full animate-spin" style={{ animationDuration: '25s', animationDirection: 'reverse' }}></div>
      </div>

      {/* Loading Text */}
      <div className="text-center space-y-4">
        <h3 className="text-xl font-heading font-semibold text-text-primary">
          {message}
        </h3>
        
        <div className="flex items-center justify-center space-x-2 text-text-secondary">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-secondary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-accent rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>

        {/* Astrological Loading Messages */}
        <div className="glass bg-surface/30 rounded-lg p-4 max-w-sm">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Zap" size={16} color="#F59E0B" />
            <span className="text-sm font-medium text-accent">Current Activity</span>
          </div>
          <p className="text-sm text-text-secondary">
            Analyzing planetary positions and harmonic frequencies...
          </p>
        </div>
      </div>

      {/* Background Animation */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-10">
        <div className="absolute top-1/4 left-1/4 w-1 h-1 bg-primary rounded-full animate-gentle-pulse"></div>
        <div className="absolute top-1/3 right-1/3 w-1.5 h-1.5 bg-secondary rounded-full animate-gentle-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/4 left-1/3 w-1 h-1 bg-accent rounded-full animate-gentle-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute bottom-1/3 right-1/4 w-2 h-2 bg-primary rounded-full animate-gentle-pulse" style={{ animationDelay: '0.5s' }}></div>
        <div className="absolute top-1/2 left-1/6 w-1 h-1 bg-secondary rounded-full animate-gentle-pulse" style={{ animationDelay: '1.5s' }}></div>
        <div className="absolute top-3/4 right-1/6 w-1.5 h-1.5 bg-accent rounded-full animate-gentle-pulse" style={{ animationDelay: '2.5s' }}></div>
      </div>
    </div>
  );
};

export default LoadingState;